import { render, staticRenderFns } from "./pricing-form.vue?vue&type=template&id=cd1649d2"
import script from "./pricing-form.vue?vue&type=script&lang=js"
export * from "./pricing-form.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports